 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_SERIES_PAGE from '@/components/html/01_Series_Page'
 import HTML04_NATIONAL_BUREAU_OF_ECONOMIC_RESE from '@/components/html/04_National_Bureau_of_Economic_Rese'
 import HTML05_RELATION_OF_THE_DIRECTORS_TO_THE from '@/components/html/05_Relation_of_the_Directors_to_the'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_PREFATORY_NOTE from '@/components/html/07_Prefatory_Note'
 import HTML08_ACKNOWLEDGMENTS from '@/components/html/08_Acknowledgments'
 import HTML09_INTRODUCTION from '@/components/html/09_Introduction'
 import HTML10_I__INCOME_INEQUALITY from '@/components/html/10_I__INCOME_INEQUALITY'
 import HTML11_1__IN_SEARCH_OF_THE_ROOTS_OF_AME from '@/components/html/11_1__In_Search_of_the_Roots_of_Ame'
 import HTML12_2__RISING_BETWEEN_FIRM_INEQUALIT from '@/components/html/12_2__Rising_Between_Firm_Inequalit'
 import HTML13_3__UNITED_STATES_EARNINGS_DYNAMI from '@/components/html/13_3__United_States_Earnings_Dynami'
 import HTML14_4__EVIDENCE_FROM_UNIQUE_SWISS_TA from '@/components/html/14_4__Evidence_from_Unique_Swiss_Ta'
 import HTML15_II__WEALTH_INEQUALITY from '@/components/html/15_II__WEALTH_INEQUALITY'
 import HTML16_5__THE_WEALTH_OF_GENERATIONS__WI from '@/components/html/16_5__The_Wealth_of_Generations__wi'
 import HTML17_6__WEALTH_TRANSFERS_AND_NET_WEAL from '@/components/html/17_6__Wealth_Transfers_and_Net_Weal'
 import HTML18_7__ON_THE_DISTRIBUTION_OF_ESTATE from '@/components/html/18_7__On_the_Distribution_of_Estate'
 import HTML19_8__STRUCTURING_THE_ANALYSIS_OF_W from '@/components/html/19_8__Structuring_the_Analysis_of_W'
 import HTML20_9__SOCIAL_SECURITY_WEALTH__INEQU from '@/components/html/20_9__Social_Security_Wealth__Inequ'
 import HTML21_III__INCOME_AND_WEALTH_MOBILITY from '@/components/html/21_III__INCOME_AND_WEALTH_MOBILITY'
 import HTML22_10__PARENTAL_EDUCATION_AND_THE_R from '@/components/html/22_10__Parental_Education_and_the_R'
 import HTML23_11__INEQUALITY_OF_OPPORTUNITY_FO from '@/components/html/23_11__Inequality_of_Opportunity_fo'
 import HTML24_12__PRESENCE_AND_PERSISTENCE_OF from '@/components/html/24_12__Presence_and_Persistence_of'
 import HTML25_13__INTERGENERATIONAL_HOME_OWNER from '@/components/html/25_13__Intergenerational_Home_Owner'
 import HTML26_14__INEQUALITY_AND_MOBILITY_OVER from '@/components/html/26_14__Inequality_and_Mobility_over'
 import HTML27_IV__MITIGATING_INEQUALITY from '@/components/html/27_IV__MITIGATING_INEQUALITY'
 import HTML28_15__THE_ACCURACY_OF_TAX_IMPUTATI from '@/components/html/28_15__The_Accuracy_of_Tax_Imputati'
 import HTML29_16__GEOGRAPHIC_INEQUALITY_IN_SOC from '@/components/html/29_16__Geographic_Inequality_in_Soc'
 import HTML30_17__INEQUALITY_AND_THE_SAFETY_NE from '@/components/html/30_17__Inequality_and_the_Safety_Ne'
 import HTML31_18__THE_EITC_AND_LINKING_DATA_FO from '@/components/html/31_18__The_EITC_and_Linking_Data_fo'
 import HTML32_V__DISTRIBUTIONAL_NATIONAL_ACCOU from '@/components/html/32_V__DISTRIBUTIONAL_NATIONAL_ACCOU'
 import HTML33_19__DISTRIBUTING_PERSONAL_INCOME from '@/components/html/33_19__Distributing_Personal_Income'
 import HTML34_20__DEVELOPING_INDICATORS_OF_INE from '@/components/html/34_20__Developing_Indicators_of_Ine'
 import HTML35_21__DISTRIBUTIONAL_NATIONAL_ACCO from '@/components/html/35_21__Distributional_National_Acco'
 import HTML36_22__THE_DISTRIBUTIONAL_FINANCIAL from '@/components/html/36_22__The_Distributional_Financial'
 import HTML37_23__USING_TAX_DATA_TO_BETTER_CAP from '@/components/html/37_23__Using_Tax_Data_to_Better_Cap'
 import HTML38_CONTRIBUTORS from '@/components/html/38_Contributors'
 import HTML38_NOTES from '@/components/html/38_Notes'
 import HTML39_AUTHOR_INDEX from '@/components/html/39_Author_Index'
 import HTML40_SUBJECT_INDEX from '@/components/html/40_Subject_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Prefatory_Note",
 			"name" : "html/07_Prefatory_Note",
 			"component" : HTML07_PREFATORY_NOTE
 		},
 		{
 			"path" : "/html/08_Acknowledgments",
 			"name" : "html/08_Acknowledgments",
 			"component" : HTML08_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/html/09_Introduction",
 			"name" : "html/09_Introduction",
 			"component" : HTML09_INTRODUCTION
 		},
 		{
 			"path" : "/html/10_I__INCOME_INEQUALITY",
 			"name" : "html/10_I__INCOME_INEQUALITY",
 			"component" : HTML10_I__INCOME_INEQUALITY
 		},
 		{
 			"path" : "/html/11_1__In_Search_of_the_Roots_of_Ame",
 			"name" : "html/11_1__In_Search_of_the_Roots_of_Ame",
 			"component" : HTML11_1__IN_SEARCH_OF_THE_ROOTS_OF_AME
 		},
 		{
 			"path" : "/html/12_2__Rising_Between_Firm_Inequalit",
 			"name" : "html/12_2__Rising_Between_Firm_Inequalit",
 			"component" : HTML12_2__RISING_BETWEEN_FIRM_INEQUALIT
 		},
 		{
 			"path" : "/html/13_3__United_States_Earnings_Dynami",
 			"name" : "html/13_3__United_States_Earnings_Dynami",
 			"component" : HTML13_3__UNITED_STATES_EARNINGS_DYNAMI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js